import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import API from '@/common/api'

// 모든모듈 modules로 임포트
import * as modules from './modules/'

Vue.use(Vuex)

// VUEX 스토어 생성
const store = new Vuex.Store({
  // 전역 상태로 사용할것이 있다면 이곳에 추가
  state: {
    rendered: false,
    loading: false,
    dataVariable: []
  },
  mutations: {
    rendered (state, boolean) {
      state.rendered = boolean
    },
    onLoading (state, boolean) {
      state.loading = boolean
    }
  },
  actions: {
    setCommon ({ dispatch }) {
      // set data variable
      dispatch('getVariable')
      // set setting data
      store.dispatch('setting/setSettingData', { root: true })
      // set category data
      store.dispatch('category/setCategoryData', { root: true })
      // set menu list data
      store.dispatch('menu/setMenuListData', { root: true })
    },
    async getVariable ({ state }, space) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-variables',
          func: 'get-user-variables',
          id: store.state.authentication.requestId
        })
        state.dataVariable = res.data.message
        return res
      } catch (ex) {
        return false
      }
    }
  },
  modules: modules.default
})

export default store
